@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<app-widget-markdown-editor
  #markdownEditor
  [(content)]="text"
  [mode]="mode"
  (editFinished)="onEditFinished()"
></app-widget-markdown-editor>
